<script lang="ts" setup>
	/**
	 * Marque Monaco Taxi.
	 *
	 * Dessinée en SVG plutôt qu'en image : elle reste nette du téléphone à
	 * l'écran de borne, suit la couleur du thème et ne coûte aucune requête —
	 * ce qui compte pour un premier affichage hors connexion.
	 */
	withDefaults(
		defineProps<{
			color?: string;
			compact?: boolean;
		}>(),
		{
			color: 'currentColor',
			compact: false,
		},
	);
</script>

<template>
	<div class="monaco-logo" :class="{ 'monaco-logo--compact': compact }" :style="{ color }">
		<!-- Couronne princière stylisée -->
		<svg class="monaco-logo_crown" viewBox="0 0 64 40" fill="none" aria-hidden="true">
			<path
				d="M6 34 L4 12 L18 22 L32 4 L46 22 L60 12 L58 34 Z"
				fill="currentColor"
			/>
			<circle cx="4" cy="9" r="3.5" fill="currentColor" />
			<circle cx="32" cy="3" r="3.5" fill="currentColor" />
			<circle cx="60" cy="9" r="3.5" fill="currentColor" />
		</svg>

		<div class="monaco-logo_word">MONACO</div>
		<div class="monaco-logo_sub">
			<span class="monaco-logo_rule" />
			<span>TAXI</span>
			<span class="monaco-logo_rule" />
		</div>
	</div>
</template>

<style lang="scss">
	.monaco-logo {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: rgb(var(--v-theme-primary));
		line-height: 1;

		&_crown {
			width: 38%;
			max-width: 64px;
			margin-bottom: 0.35em;
		}

		&_word {
			font-size: 2.2em;
			font-weight: 500;
			letter-spacing: 0.22em;
			// Le décalage compense l'espacement ajouté après la dernière lettre.
			text-indent: 0.22em;
		}

		&_sub {
			display: flex;
			align-items: center;
			gap: 0.6em;
			margin-top: 0.35em;
			font-size: 1.1em;
			font-weight: 500;
			letter-spacing: 0.34em;
			text-indent: 0.34em;
		}

		&_rule {
			display: block;
			width: 1.6em;
			height: 1px;
			background: currentColor;
		}

		&--compact {
			flex-direction: row;
			align-items: center;
			gap: 0.5em;

			.monaco-logo_crown {
				width: 1.6em;
				margin-bottom: 0;
			}

			.monaco-logo_word {
				font-size: 1.1em;
				letter-spacing: 0.14em;
			}

			.monaco-logo_sub {
				margin-top: 0;
				font-size: 0.9em;

				.monaco-logo_rule {
					display: none;
				}
			}
		}
	}
</style>
